var config = {
    'share-selected-text': true,
    'load-more': false,
    'infinite-scroll': false,
    'infinite-scroll-step': 1,
    'disqus-shortname': 'hauntedthemes-demo',
    'content-api-host': 'https://edigerconstructionandwoodworking.com',
    'content-api-key': '93df3021dd59d3aa3e598a03f0',
};